// extracted by mini-css-extract-plugin
module.exports =  {"root":"y7HbGFXHthy2x7bsUMyJ","link":"vo7uf8UmDvnwlyC46hnq"};